import React from 'react';

export function Button({ 
  children, 
  variant = 'primary', 
  size = 'md', 
  className = '', 
  ...props 
}) {
  const baseStyles = "inline-flex items-center justify-center font-semibold rounded-lg transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2";
  
  const variants = {
    primary: "bg-brand-green text-white hover:bg-emerald-600 focus:ring-brand-green",
    secondary: "bg-brand-navy text-white hover:bg-blue-900 focus:ring-brand-navy",
    outline: "border-2 border-gray-200 text-gray-700 hover:border-brand-green hover:text-brand-green focus:ring-brand-green",
    danger: "bg-brand-red text-white hover:bg-red-600 focus:ring-brand-red",
  };

  const sizes = {
    sm: "px-4 py-2 text-sm",
    md: "px-6 py-3 text-base",
    lg: "px-8 py-4 text-lg",
  };

  return (
    <button 
      className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`}
      {...props}
    >
      {children}
    </button>
  );
}